import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import LoadingSpinner from "../../components/LoadingSpinner";

// Pages a plain admin does not see in the sidebar: a typed URL leads back
// to the campaigns list.
const SuperAdminRoute: React.FC = () => {
  const { user, loading } = useUser();

  if (loading && !user) {
    return <LoadingSpinner />;
  }

  return user?.role === "SUPER_ADMIN" ? (
    <Outlet />
  ) : (
    <Navigate to="/campaigns" replace />
  );
};

export default SuperAdminRoute;
